export default __webpack_public_path__ + "static/media/es-buurebueebli.49ab0d1c.png";